import { render, staticRenderFns } from "./general-bill-settings.vue?vue&type=template&id=8a0b10a2"
import script from "./general-bill-settings.vue?vue&type=script&lang=js"
export * from "./general-bill-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports